import moment from "moment";

import serviceBase from "./serviceBase";
import CheckinService from "./checkinService";
import CheckoutService from "./checkoutService";

import event from "../models/event";
import user from "../models/user";
import Store from "../store";
import { EndPoint } from "../appConfig";
import { declined } from "../models/status";

const store = new Store();
var MeetingService = Object.create(new serviceBase(EndPoint.Event));
/**
 * targetのアクティブ(現在～チェックイン可能時間)な会議情報を、取得し、successをコールします。
 *
 * @param {String} target
 * @param {function} success
 */
MeetingService.getActiveEvent = function(target, success) {
  var now = new Date();
  var end = moment(now)
    .add(store.tenant.allowMinCheckinBefore, "m")
    .toDate();
  return MeetingService.getEvent(target, now, end, success);
};
/**
 * targetのstartDate～endDateの会議情報を、取得し、successをコールします。
 * @param {String} target
 * @param {Date} startDate
 * @param {Date} endDate
 * @param {function} success
 */
MeetingService.getEvent = function(target, startDate, endDate, success) {
  return this.get({
    user: target,
    start_date: startDate.toISOString(),
    end_date: endDate.toISOString()
  }).then(function(res) {
    var events = [];
    var promises = [];
    var promisesCheckouts = [];
    var isCheckind = false;
    var isCheckouted = false;
    for (var i = 0; i < res.length; i++) {
      events.push(parseToEvent(res[i]));
      promises.push(CheckinService.getCheckinsById(events[i].icalId));
      promisesCheckouts.push(
        CheckoutService.getCheckoutsById(events[i].icalId)
      );
    }
    Promise.all(promises).then(function(checkins) {
      for (var i = 0, count = checkins.length; i < count; i++) {
        var checkin = checkins[i];
        if (checkin && checkin.length) {
          events[i].checkins = checkin.map(c => c.user);
        }
      }
      isCheckind = true;
      if (isCheckouted) {
        events = events.sort(sortByStartTime);
        success(events);
      }
    });
    Promise.all(promisesCheckouts).then(function(checkouts) {
      for (var i = 0, count = checkouts.length; i < count; i++) {
        var checkout = checkouts[i];
        if (checkout && checkout.length) {
          events[i].checkouts = checkout.map(c => c.user);
        }
      }
      isCheckouted = true;
      if (isCheckind) {
        events = events.sort(sortByStartTime);
        success(events);
      }
    });
  });
};
/**
 *
 * targetのstartDate～endDateの会議情報を、取得し、successをコールします。
 * データにチェックイン情報が含まれません。
 *
 * @param {String} target
 * @param {Date} startDate
 * @param {Date} endDate
 */
MeetingService.getEventWithOutCheckins = function(
  target,
  startDate,
  endDate,
  error
) {
  return this.get(
    {
      user: target,
      start_date: startDate.toISOString(),
      end_date: endDate.toISOString()
    },
    error ? true : false
  ).then(function(res) {
    var events = [];
    for (var i = 0; i < res.length; i++) {
      events.push(parseToEvent(res[i]));
    }
    return new Promise(function(resolve) {
      events = events.sort(sortByStartTime);
      resolve({
        target,
        events
      });
    });
  }, error);
};
/**
 * 指定されたidの会議室の終了時刻をendDateに変更します。
 *
 * @param {String} id
 * @param {Date} endDate
 */
MeetingService.updateEndTime = function(id, endDate) {
  return this.patch(
    id,
    {
      end_date: endDate.toISOString()
    },
    {
      targetTime: endDate.toISOString()
    }
  );
};
/**
 * 指定されたbaseEventを延長します。
 */
MeetingService.expand = function(baseEvent, room, endDate, success) {
  return this.post({
    subject: baseEvent.subject + store.expandAppendSubject,
    rooms: [
      {
        address: room
      }
    ],
    requiredUsers: [
      {
        id: store.account
      }
    ],
    optionalUsers: [],
    start_date: baseEvent.endDate.toISOString(),
    end_date: endDate.toISOString(),
    relation_meeting_id: baseEvent.icalId
  }).then(event => {
    var evt = parseToEvent(event);
    success(evt);
  });
};
/**
 * 指定された部屋を予約します。
 */
MeetingService.book = function(room, startDate, endDate, success) {
  if (!startDate)
    startDate = new Date(
      Math.ceil(new Date().getTime() / 1000 / 60 / 5) * 1000 * 60 * 5
    );
  var bookingData = {
    subject: store.simpleBookSubject,
    rooms: [
      {
        address: room
      }
    ],
    required: [
      {
        id: store.account
      }
    ],
    optional: [],
    start_date: startDate.toISOString(),
    end_date: endDate.toISOString()
  };
  return this.post(bookingData).then(event => {
    var evt = parseToEvent(event);
    success(evt);
  });
};

MeetingService.extractCurrentMeeting = function(events, room) {
  for (var i = 0, count = events.length; i < count; i++) {
    for (var j = 0, jcount = events[i].rooms.length; j < jcount; j++) {
      if (
        events[i].rooms[j].id == room.id &&
        events[i].rooms[j].status != declined
      ) {
        return events[i];
      }
    }
    for (
      var j2 = 0, jcount2 = events[i].requiredUsers.length;
      j2 < jcount2;
      j2++
    ) {
      if (
        events[i].requiredUsers[j2].address.toUpperCase() ==
          room.address.toUpperCase() &&
        events[i].requiredUsers[j2].status != declined
      ) {
        return events[i];
      }
    }
  }
};

// サーバーのオブジェクトを変換します。
function parseToEvent(current) {
  return Object.assign(new event(), {
    id: current.id,
    icalId: current.ical_uid,
    subject: current.subject,
    rooms: current.rooms
      .filter(r => r.id)
      .map(r =>
        Object.assign(new user(), {
          id: r.id,
          address: r.address,
          status: r.status,
          display: r.name
        })
      ),
    isAllDay: current.is_all_day,
    requiredUsers: current.required.map(r => Object.assign(new user(), r)),
    optionalUsers: current.optional.map(o => Object.assign(new user(), o)),
    organizer: Object.assign(new user(), current.organizer),
    startDate: new Date(Date.parse(current.start_date)),
    endDate: new Date(Date.parse(current.end_date))
  });
}
/*
 * 開始順でソートします。
 */
function sortByStartTime(a, b) {
  return a.startDate > b.startDate ? 1 : b.startDate > a.startDate ? -1 : 0;
}

export default MeetingService;
